import { Button, Card, Steps, Typography } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Can } from '@/shared/auth/Can'

interface OrgSetupGuideProps {
  onStart: () => void
}

export function OrgSetupGuide({ onStart }: OrgSetupGuideProps) {
  const { t } = useTranslation()

  return (
    <Card title={t('org.guide.title')} style={{ marginBottom: 16 }}>
      <Typography.Paragraph type="secondary">{t('org.guide.intro')}</Typography.Paragraph>
      <Steps
        direction="vertical"
        size="small"
        current={0}
        items={[
          { title: t('org.guide.headOffice'), description: t('org.guide.headOfficeHint') },
          { title: t('org.guide.branches'), description: t('org.guide.branchesHint') },
          { title: t('org.guide.departments'), description: t('org.guide.departmentsHint') },
        ]}
      />
      <Can permission="org.node.write">
        <Button type="primary" icon={<PlusOutlined />} onClick={onStart}>
          {t('org.createHeadOffice')}
        </Button>
      </Can>
      <Typography.Paragraph type="secondary" style={{ marginTop: 16, marginBottom: 0 }}>
        {t('org.agentsNote')}{' '}
        <Can permission="agent.read">
          <Link to="/agents">{t('nav.agents')}</Link>
        </Can>
      </Typography.Paragraph>
    </Card>
  )
}
